import { Box, CircularProgress, Typography } from "@mui/material";
import IntegrationFilesPanel from "components/integrations-list/IntegrationFilesPanel";
import type { IntegrationUserFolderResponse } from "features/integrations/integrations";
import { useGetIntegrationFolderQuery } from "features/integrationsBeta/integrationsBeta";

interface Props {
  integrationId: number;
  integrationName: string;
}

/**
 * Files tab for an integration-platform integration. Resolves the bound
 * UserFolder via the platform endpoint, then reuses the shared Data-Storage
 * file browser (listing / preview / download / search / sort) by passing the
 * folder metadata directly.
 */
export default function FilesPanel({ integrationId, integrationName }: Props) {
  const {
    data: folder,
    isLoading,
    isError,
  } = useGetIntegrationFolderQuery(integrationId);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ p: 6 }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !folder) {
    return (
      <Typography color="error" sx={{ p: 2 }}>
        Could not load the files folder for this integration.
      </Typography>
    );
  }

  const folderMeta: IntegrationUserFolderResponse = {
    success: true,
    user_folder: {
      id: folder.id,
      folder: folder.folder,
      folder_prefix: folder.folder_prefix,
      sync_status: folder.sync_status,
      s3_bucket: folder.s3_bucket,
    },
    message: "",
  };

  return (
    <IntegrationFilesPanel
      folderMetaOverride={folderMeta}
      integrationLabel={integrationName}
      canUseFileDateFeatures
    />
  );
}
